import React from 'react'
import PropTypes from 'prop-types'
import { GoogleMap, LoadScriptNext, Marker } from '@react-google-maps/api'

const Locations = ({ places }) => {
  // console.log(process.env.NEXT_PUBLIC_GOOGLE_API_KEY)
  return (
    <LoadScriptNext googleMapsApiKey={process.env.NEXT_PUBLIC_GOOGLE_API_KEY}>
      <GoogleMap
        mapContainerStyle={{
          width: '100%',
          height: '600px',
          position: 'sticky',
          top: 0,
          margin: '20px 0 36px',
        }}
        center={{
          lat: parseFloat(process.env.NEXT_PUBLIC_LATITUDE),
          lng: parseFloat(process.env.NEXT_PUBLIC_LONGITUDE),
        }}
        zoom={9}
      >
        {places.map((place, i) => {
          return (
            <>
              {place.location &&
                place.location.lat !== '' &&
                place.location.lng !== '' && (
                  <Marker
                    key={i}
                    position={{
                      lat: place.location.lat,
                      lng: place.location.lng,
                    }}
                    title={place.name}
                    onClick={() => {
                      const card = document.getElementById(`${place.slug}`)
                      if (card) {
                        if (window.innerWidth < 981) {
                          window.scrollTo(
                            0,
                            card.offsetTop + window.innerHeight
                          )
                        } else {
                          window.scrollTo(0, card.offsetTop)
                        }
                      }
                    }}
                    icon={{
                      url: '/static/images/marker.png',
                      // @ts-ignore
                      scaledSize: { width: 32, height: 32 },
                    }}
                  />
                )}
            </>
          )
        })}
      </GoogleMap>
    </LoadScriptNext>
  )
}
Locations.propTypes = {
  places: PropTypes.array,
}
export default Locations
